import { Fragment } from "react";
import { Link } from "@tanstack/react-router";
import { Section } from "@/components/Section";
import { CtaPanel } from "@/components/CtaPanel";
import type { Location } from "@/content/locations";
import { isPairedCity } from "@/content/language-pairs";

/** Closing call to action with the city hub's footer link row. */
export function CityHubCta({ loc }: { loc: Location }) {
  const isRangpur = loc.slug === "rangpur";
  const footerLinks = [
    { to: "/services", label: "Services" },
    { to: "/case-studies", label: "Case studies" },
    { to: "/process", label: "Process" },
    { to: "/contact", label: "Contact" },
    { to: "/seo-locations", label: "All locations" },
  ] as const;

  return (
    <Section className="!pt-0">
      <CtaPanel
        title={isRangpur ? "Plan your next SEO step in Rangpur" : `Ready to win ${loc.city} search?`}
        body={
          isRangpur
            ? "Share your website, real service area and goals. We’ll identify priorities and agree a scope before starting."
            : "Let's map the local SERPs you should be ranking for and the quickest path to get there."
        }
        primary={{ to: "/contact", label: <>Start a {loc.city} SEO project</> }}
        secondary={{ to: "/services", label: "Explore services" }}
      >
        <p className="mt-6 text-xs text-muted-foreground">
          {footerLinks.map((l) => (
            <Fragment key={l.to}>
              <Link to={l.to} className="underline">
                {l.label}
              </Link>{" "}
              ·{" "}
            </Fragment>
          ))}
          <Link to="/seo-services" className="underline">
            Every {loc.city} service page in the city × service index
          </Link>
          {isPairedCity(loc.slug) && (
            <>
              {" "}
              ·{" "}
              <Link
                to="/bn/seo-services/$location"
                params={{ location: loc.slug }}
                hrefLang="bn"
                className="underline"
              >
                {loc.city} এসইও — বাংলায় পড়ুন
              </Link>
            </>
          )}
        </p>
      </CtaPanel>
    </Section>
  );
}
